import { createSlice } from "@reduxjs/toolkit";
import { 
  getTemplate, 
  updateTemplate, 
  deleteTemplate
} from "./actions";

export const initialState = {
  template: { id: '', name: '', file: null, pages: [], elements: [], pages_count: 0, created_at: '', updated_at: '' },
  loading: false
};

const slice = createSlice({
  name: 'templates',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTemplate.fulfilled, (state, action) => {
        const { template } = action.payload;
        const updatedTemplate = { ...state.template, ...template };

        state.loading = false;
        state.template = updatedTemplate;
      })
      .addCase(getTemplate.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTemplate.fulfilled, (state, action) => {
        const { status, template } = action.payload;
        const updatedTemplate = { ...state.template, ...template };

        state.loading = false;
        if (status === 204) {
          state.template = updatedTemplate;
        }  
      })
      .addCase(updateTemplate.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteTemplate.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteTemplate.fulfilled, (state, action) => {
        const { status } = action.payload;

        if (status === 204) {
          state.loading = false;
        }
      })
      .addCase(deleteTemplate.rejected, (state) => {
        state.loading = false;
      })
  }
})

export default slice.reducer;